import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    orderType1: ''
  },
  mutations: {
    isLogin(state,value) {
      state.orderType1 = value;
    }
  }
})
export default store